export default __webpack_public_path__ + "assets/partly-cloudy-night-rain.6a1e50d9.svg";